import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  taskTaskgroups(filter) {
    return Api()
      .get('/tasktaskgroups', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  taskTaskgroup(taskTaskgroupId) {
    return Api()
      .get('/tasktaskgroup/' + taskTaskgroupId)
      .then((res) => this.formatRes(res.data));
  },
  create(taskTaskgroup) {
    return Api()
      .post('/tasktaskgroup', taskTaskgroup)
      .then((res) => this.formatRes(res.data));
  },
  update(taskTaskgroup) {
    return Api()
      .put('/tasktaskgroup/' + taskTaskgroup.id, taskTaskgroup)
      .then((res) => this.formatRes(res.data));
  },
  delete(taskTaskgroup) {
    return Api()
      .delete('/tasktaskgroup/' + taskTaskgroup.id)
      .then(() => taskTaskgroup);
  },
  increase(taskTaskgroup) {
    return Api()
      .put('/tasktaskgroup/increase/' + taskTaskgroup.id)
      .then(() => taskTaskgroup);
  },
  decrease(taskTaskgroup) {
    return Api()
      .put('/tasktaskgroup/decrease/' + taskTaskgroup.id)
      .then(() => taskTaskgroup);
  },
  formatRes(e) {
    return e;
  },
};
